(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["happy-pets-mega-menu"] && !Shopify.designMode) return;
  try {
    function initHappyPetsNav(){
document.querySelectorAll('.hp-nav:not([data-ready])').forEach(nav=>{
nav.dataset.ready='true';
const groups=[...nav.querySelectorAll('details')];
const hover=window.matchMedia('(hover:hover) and (pointer:fine) and (min-width:750px)');
const closeAll=()=>groups.forEach(group=>group.open=false);
groups.forEach(group=>{
let timer;
group.addEventListener('pointerenter',()=>{if(hover.matches){clearTimeout(timer);groups.forEach(other=>{if(other!==group)other.open=false});group.open=true}});
group.addEventListener('pointerleave',()=>{if(hover.matches)timer=setTimeout(()=>{if(!group.contains(document.activeElement))group.open=false},150)});
group.addEventListener('toggle',()=>{if(group.open)groups.forEach(other=>{if(other!==group)other.open=false})});
});
groups.forEach(group => {
  const summary = group.querySelector('summary');
  if (!summary) return;

  summary.addEventListener('click', () => {
    if (window.matchMedia('(hover: none)').matches) {
      groups.forEach(other => {
        if (other !== group) other.open = false;
      });
    }
  });
});
nav.addEventListener('keydown',event=>{if(event.key==='Escape'){const active=groups.find(group=>group.open);closeAll();active?.querySelector('summary').focus()}});
document.addEventListener('click',event=>{if(!nav.contains(event.target))closeAll()});
nav.addEventListener('focusout',()=>setTimeout(()=>{if(!nav.contains(document.activeElement))closeAll()},0));
});
}
initHappyPetsNav();
document.addEventListener('shopify:section:load',initHappyPetsNav);
  } catch(e) { console.error(e); }
})();

})();
